import { useHistory } from 'react-router';
import { rewrite, rewriteInverse } from './rewrite';

export function useLink(path?: string): string | undefined {
	const history = useHistory();

	if (path === undefined) {
		return undefined;
	}

	if (history.location.pathname.startsWith('/v2')) {
		return rewrite(path);
	} else {
		return rewriteInverse(path);
	}
}
